import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';

class LoadLanguageData extends React.Component {
    componentDidUpdate(prevProps) {
        if (!prevProps.clientConfig?.textTemplates && this.props.clientConfig?.textTemplates) {
            const parsedTemplates = this.props.clientConfig.textTemplates ?? {};

            if (parsedTemplates?.client) {
                Object.keys(parsedTemplates.client).forEach((lang) => {
                    this.props.addTranslationForLanguage(parsedTemplates.client[lang], lang);
                });
            }
        }
    }

    render() {
        return null;
    }
}

LoadLanguageData.propTypes = {
    addTranslationForLanguage: PropTypes.func.isRequired,
    clientConfig: PropTypes.object,
};

LoadLanguageData.defaultProps = {
    clientConfig: null,
};

const mapStateToProps = state => ({
    clientConfig: state.auth.clientConfig,
});

export default connect(mapStateToProps)(withLocalize(LoadLanguageData));
